"use client"

import { UserRoundPen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UserRoundPenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UserRoundPenIcon = component(Icon)({ as: UserRoundPen })
